import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

import firebase, { auth as firebaseAuth } from '../../config/firebase';
import api from '../../lib/api';
import logo from '../../images/logo.svg';
import Styled from './styles';
import { loginSuccess } from '../../reducers/auth';

const GoogleIcon = () => (
  <svg viewBox="0 0 48 48">
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
  </svg>
);

class FirebaseLogin extends Component {
  static propTypes = {
    loginSuccess: PropTypes.func,
  };

  state = {
    loading: false,
    error: null,
  };

  handleAuthResult = async firebaseUser => {
    const { loginSuccess } = this.props;

    const idToken = await firebaseUser.getIdToken();
    const { authorized, roles } = await api.firebaseLogin({ idToken });

    if (authorized) {
      loginSuccess({ authorized, roles });
      window.location.href = '/';
    } else {
      this.setState({
        loading: false,
        error: 'Account not authorized. Contact QuickSell to authorize your account.',
      });
    }
  };

  onGoogleLogin = async () => {
    this.setState({ loading: true, error: null });

    try {
      const provider = new firebase.auth.GoogleAuthProvider();
      provider.setCustomParameters({ prompt: 'select_account' });
      const result = await firebaseAuth.signInWithPopup(provider);
      await this.handleAuthResult(result.user);
    } catch (ex) {
      this.setState({
        loading: false,
        error: `[${ex.code || 'unknown'}] ${ex.message || 'Google sign-in failed. Please try again.'}`,
      });
    }
  };

  onSnackbarClose = () => this.setState({ error: null });

  render() {
    const { loading, error } = this.state;

    return (
      <Styled.Container>
        <Styled.Card>
          <Styled.Logo>
            <img src={logo} alt="QuickSell" />
            <span>QuickSell</span>
          </Styled.Logo>

          <Styled.Title>Sign in to Internal Dashboard</Styled.Title>

          <Styled.DomainHint>quicksell.co · doubletick.io · doubletick.com</Styled.DomainHint>

          <Styled.GoogleButton onClick={this.onGoogleLogin} disabled={loading}>
            {loading
              ? <CircularProgress size={18} thickness={5} />
              : <GoogleIcon />
            }
            Sign in with Google
          </Styled.GoogleButton>
        </Styled.Card>

        <Snackbar
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          open={!!error}
          autoHideDuration={6000}
          onClose={this.onSnackbarClose}
          message={<Styled.SnackbarMessage>{error}</Styled.SnackbarMessage>}
          action={[
            <IconButton key={0} onClick={this.onSnackbarClose}>
              <CloseIcon nativeColor="#fff" />
            </IconButton>,
          ]}
        />
      </Styled.Container>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  loginSuccess: (...params) => dispatch(loginSuccess(...params)),
});

export default connect(
  null,
  mapDispatchToProps
)(FirebaseLogin);



// WEBPACK FOOTER //
// ./src/pages/FirebaseLogin/index.js